import * as React from "react";


export default function MonitoringAlarmsPage() {
  return (
    <h1>hello</h1>
  );
}